/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaText/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaText({
  children,
  viewPath = "/DesignSystem/TysiaText",
  color,
  className = "text",
  fontFamily = "Inter",
  fontSize = 13,
  fontStyle = "normal",
  lineHeight = "20px",
  marginTop = 0,
  marginBottom = 0,
  marginRight = 0,
  marginLeft = 0,
  paddingTop = 0,
  paddingRight = 0,
  paddingBottom = 0,
  paddingLeft = 0,
  textAlign = "left",
  width = "auto",
  maxWidth = "auto",
  minWidth = "auto",
  height = "auto",
  maxHeight = "auto",
  textOverflow = "clip",
  order = "no",
  whiteSpace = "normal",
  overflowX,
  overflowY,
  hyphens = "none",
  textDecoration = "none",
  textUnderlineOffset,
  textTransform = "none",
  cursor,
  letterSpacing,
  display = "flex",
  opacity,
  text = "",
  title,
  flexGrow,
  flexShrink,
  flexBasis,
  wordBreak,
  size,
  weight
  
}) {
let dtTysiatextColorPrimaryBase = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'TysiaText.color.primary.base'
        })
let colorOrdtTysiatextColorPrimaryBase = color ?? dtTysiatextColorPrimaryBase
  return (<React.Fragment
>
<span
  data-testid="TysiaText.Text"
  data-view-path={viewPath}
 textUnderlineOffset={textUnderlineOffset}
 title={title}
 style={{'--c-1-1bFlFs': colorOrdtTysiatextColorPrimaryBase,'--ff-2-1bFlFs': fontFamily,'--fs-4-1bFlFs': fontStyle,'--mt-7-1bFlFs': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-8-1bFlFs': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--mr-9-1bFlFs': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--ml-10-1bFlFs': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--pt-11-1bFlFs': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--pr-12-1bFlFs': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pb-13-1bFlFs': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-14-1bFlFs': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--ta-15-1bFlFs': textAlign,'--w-16-1bFlFs': typeof width === 'number' ? `${width}px` : width,'--mw-17-1bFlFs': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--mw-18-1bFlFs': typeof minWidth === 'number' ? `${minWidth}px` : minWidth,'--h-19-1bFlFs': typeof height === 'number' ? `${height}px` : height,'--mh-20-1bFlFs': typeof maxHeight === 'number' ? `${maxHeight}px` : maxHeight,'--to-21-1bFlFs': textOverflow,'--o-22-1bFlFs': order,'--ws-23-1bFlFs': whiteSpace,'--ox-24-1bFlFs': overflowX,'--oy-25-1bFlFs': overflowY,'--h-26-1bFlFs': hyphens,'--td-27-1bFlFs': textDecoration,'--tt-28-1bFlFs': textTransform,'--c-29-1bFlFs': cursor,'--ls-30-1bFlFs': typeof letterSpacing === 'number' ? `${letterSpacing}px` : letterSpacing,'--d-31-1bFlFs': display,'--o-32-1bFlFs': opacity,'--fg-33-1bFlFs': flexGrow,'--fs-34-1bFlFs': flexShrink,'--fb-35-1bFlFs': typeof flexBasis === 'number' ? `${flexBasis}%` : flexBasis,'--wb-36-1bFlFs': wordBreak,'--fs-3-1bFlFs': size === "tiny" ? "11px" : size === "small" ? "12px" : size === "normal" ? "13px" : size === "large" ? "14px" : typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--lh-5-1bFlFs': size === "tiny" ? "13px" : size === "small" ? "16px" : size === "normal" ? "20px" : size === "large" ? "20px" : lineHeight,'--fw-6-1bFlFs': weight === "thin" ? 100 : weight === "extralight" ? 200 : weight === "light" ? 300 : weight === "regular" ? 400 : weight === "medium" ? 500 : weight === "semibold" ? 600 : weight === "bold" ? 700 : weight === "extrabold" ? 800 : weight === "black" ? 900 : 400}}
 className={`views-text ${className} ${styles.Text}`}
>
{text}
</span>
{children}
</React.Fragment>)
}